/**
 * Store for Copy & Apply drop values (campaign, gateway, senders, texts).
 * Used when copying from Stats tab tooltip and applying to selected drafts or Scale modal.
 * For Media Devoted | Created By Ciro Autiero
 */

import { create } from 'zustand';

export interface DropApplyValues {
  campaignName: string | null;
  /** null = do not change gateway when applying */
  gatewayName: string | null;
  senderNames: string[];
  /** When set, includes SMS texts to apply (Copy config + texts). */
  smsTexts?: string[];
}

interface DropApplyStoreState {
  values: DropApplyValues | null;
  setValues: (v: DropApplyValues) => void;
  clearValues: () => void;
  hasValues: () => boolean;
}

export const useDropApplyStore = create<DropApplyStoreState>()((set, get) => ({
  values: null,
  setValues: (v) => set({ values: v }),
  clearValues: () => set({ values: null }),
  hasValues: () => {
    const v = get().values;
    if (!v) return false;
    const hasCampaign = Boolean(v.campaignName?.trim());
    const hasSenders = v.senderNames?.length > 0;
    return hasCampaign || hasSenders;
  },
}));
